<script>
import { MarkerClusterer, DefaultRenderer } from '@googlemaps/markerclusterer'

class ClusterRenderer extends DefaultRenderer {
  constructor(gmapApi) {
    console.log('views.gmap-cluster.cluster-rederer.constructor')

    super()
    this.gmapApi = gmapApi
  }

  render({ count, position }) {
    // use d3-interpolateRgb to interpolate between red and blue
    // const color = this.palette(count / stats.clusters.markers.max)
    const color = '#AFB42B'

    // Create cluster marker element with styled circle and count
    const clusterElement = document.createElement('div')
    clusterElement.style.cssText = `
      width: 75px;
      height: 75px;
      border-radius: 50%;
      background-color: ${color};
      border: 3px solid white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      color: white;
      box-shadow: 0 2px 6px rgba(0,0,0,.3);
    `
    clusterElement.textContent = String(count)

    // Create cluster marker using AdvancedMarkerElement
    const marker = new this.gmapApi.maps.marker.AdvancedMarkerElement({
      position,
      content: clusterElement,
      zIndex: Number.MAX_SAFE_INTEGER - count,
    })

    // Add compatibility methods for MarkerClusterer
    // AdvancedMarkerElement doesn't support the traditional marker API
    marker.getPosition = function () {
      return marker.position
    }

    // setMap with recursion guard to prevent infinite loop
    // The AdvancedMarkerElement's map setter internally triggers setMap
    let isSettingMap = false
    marker.setMap = function (map) {
      if (isSettingMap) return
      isSettingMap = true
      try {
        marker.map = map
      } finally {
        isSettingMap = false
      }
    }

    marker.getVisible = function () {
      return marker.map !== null
    }

    return marker
  }
}

// TODO relay of marker click...
export default {
  data: () => ({
    clusterPromiseResolveFn: null,
    cluster: null,
  }),
  inject: ['mapPromise'],
  provide: function () {
    console.log('views.gmap-cluster.provide')
    const clusterPromise = new Promise((resolve) => {
      this.clusterPromiseResolveFn = resolve
    })
    return { clusterPromise: clusterPromise }
  },

  created: async function () {
    // console.log('components.gmap-cluster.created')
    const gmap = await this.mapPromise

    this.cluster = new MarkerClusterer({
      map: gmap,
      renderer: new ClusterRenderer(this.$gmap),
    })
    this.clusterPromiseResolveFn(this.cluster)

    // console.log('components.gmap-cluster.created.cluster', this.cluster)
  },
  render: function (h) {
    // console.log('components.gmap-cluster.render')
    // Return a div that doesn't interfere with layout (display: none)
    // The markers don't render any DOM, so this container is just organizational
    const self = this
    return h(
      'div',
      {
        style: {
          display: 'none',
        },
        on: {
          // Re-emit click event.
          click: function (e) {
            console.log('components.gmap-cluster.render.on-click', e)
            self.$emit('click', e)
          },
        },
      },
      this.$slots.default
    )
  },
}
</script>
